/* eslint-disable no-console */
import { createGenerateClassName, StylesProvider, ThemeProvider } from '@material-ui/core';
import React, { memo, useMemo } from 'react';
import oriTheme from '../theme';
import { jsx as _jsx } from "react/jsx-runtime";
export const OriMuiThemeProvider = ({
  children,
  theme = oriTheme,
  enableStylesProvider,
  disableGeneration,
  generateClassName,
  disableGlobal,
  productionPrefix,
  seed,
  ...stylesProps
}) => {
  const internalTheme = useMemo(() => {
    if (typeof theme === 'function') {
      return theme(oriTheme);
    }

    return theme;
  }, [theme]);
  const classNameGenerator = useMemo(() => {
    if (generateClassName) return generateClassName;

    if (disableGlobal || productionPrefix || seed) {
      return createGenerateClassName({
        disableGlobal,
        productionPrefix,
        seed
      });
    }

    return undefined;
  }, [disableGlobal, productionPrefix, seed, generateClassName]);

  if (process.env.NODE_ENV !== 'production') {
    if (disableGlobal && !enableStylesProvider && typeof window !== 'undefined') {
      console.error(`ORI-UI: You cannot use disableGlobal without enabling styles provider.`);
    }

    if (productionPrefix && !enableStylesProvider && typeof window !== 'undefined') {
      console.error(`ORI-UI: You cannot use productionPrefix without enabling styles provider.`);
    }

    if (seed && !enableStylesProvider && typeof window !== 'undefined') {
      console.error(`ORI-UI: You cannot use seed without enabling styles provider.`);
    }

    if (generateClassName && !enableStylesProvider && typeof window !== 'undefined') {
      console.error(`ORI-UI: You cannot use generateClassName without enabling styles provider.`);
    }

    if (stylesProps.injectFirst && !enableStylesProvider && typeof window !== 'undefined') {
      console.error(`ORI-UI: You cannot use injectFirst without enabling styles provider.`);
    }

    if (stylesProps.jss && !enableStylesProvider && typeof window !== 'undefined') {
      console.error(`ORI-UI: You cannot use jss without enabling styles provider.`);
    }

    if (stylesProps.sheetsCache && !enableStylesProvider && typeof window !== 'undefined') {
      console.error(`ORI-UI: You cannot use sheetsCache without enabling styles provider.`);
    }

    if (stylesProps.sheetsManager && !enableStylesProvider && typeof window !== 'undefined') {
      console.error(`ORI-UI: You cannot use sheetsManager without enabling styles provider.`);
    }

    if (stylesProps.sheetsRegistry && !enableStylesProvider && typeof window !== 'undefined') {
      console.error(`ORI-UI: You cannot use sheetsRegistry without enabling styles provider.`);
    }
  }

  if (!enableStylesProvider) {
    return /*#__PURE__*/_jsx(ThemeProvider, {
      theme: internalTheme,
      children: children
    });
  }

  return /*#__PURE__*/_jsx(StylesProvider, {
    disableGeneration: disableGeneration,
    generateClassName: classNameGenerator,
    ...stylesProps,
    children: /*#__PURE__*/_jsx(ThemeProvider, {
      theme: internalTheme,
      children: children
    })
  });
};
OriMuiThemeProvider.displayName = 'OriMuiThemeProvider';
export default /*#__PURE__*/memo(OriMuiThemeProvider);